(async () => {
    const { Core } = await importModule('Core');
    const {
        parseHTML,
        $clone,
        Routes,
    } = await importModule('Utils');

    const NOTIFICATION_SECTION = 'r_cart-notification';

    customElements.define('cart-notification', class extends Core {
        subscriptions = {
            'cart:update': '_update',
            'cart-notification:open': '_openDirect'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'notification' });
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart-notification:open', { global: true });
            this._initCartControls(); // Initialize once
        }

        async _update(data) {
            if (data?.notification?.section) {
                const $doc = parseHTML(data.notification.section);
                this.$container = $clone($doc.querySelector('[data-content]'));
                this._openModal();
            } else {
                await this._openDirect();
            }
        }

        async _openDirect() {
            try {
                this.publish('cart:add-feature', { feature: 'notification' });

                const res = await fetch(`${Routes('root')}?section_id=${NOTIFICATION_SECTION}&_=${Date.now()}`);
                const html = await res.text();
                const $doc = parseHTML(html);
                this.$container = $clone($doc.querySelector('[data-content]'));
                this._openModal();
            } catch (e) {
                console.error('Failed to open cart notification:', e);
            }
        }

        _openModal() {
            this.publish('modal:open', {
                content: this.$container,
                position: 'top-right',
                animation: 'slideRight'
            });
            // Call after DOM is updated (modal.js ignores onOpen callback)
            requestAnimationFrame(() => this._initFeatures());
        }

        _initFeatures() {}

        _initCartControls() {
            this._initDiscountControls();

            document.addEventListener('change', (e) => {
                const $select = e.target.closest('[data-qty-select]');
                if (!$select) return;

                const $wrapper = $select.closest('[data-qty-wrapper]');
                if (!$wrapper) return;

                const quantity = parseInt($select.value, 10);
                this._showCartLoading();
                this.publish('cart:change', {
                    key: $wrapper.dataset.key,
                    quantity,
                    selling_plan: $wrapper.dataset.sellingPlan || undefined,
                    src: 'notification'
                });
            });

            document.addEventListener('click', (e) => {
                const $deleteBtn = e.target.closest('[data-delete-btn]');
                if (!$deleteBtn) return;

                e.preventDefault();
                e.stopPropagation();

                const $wrapper = $deleteBtn.closest('[data-delete-wrapper]');
                if (!$wrapper) return;

                this._showCartLoading();
                this.publish('cart:change', {
                    key: $wrapper.dataset.key,
                    quantity: 0,
                    selling_plan: $wrapper.dataset.sellingPlan || undefined,
                    src: 'notification'
                });
            });
        }

        _showCartLoading() {
            const $modal = document.querySelector('modal-popup');
            if (!$modal) return;
            const $body = $modal.querySelector('[data-items-container]')?.parentElement;
            if ($body) $body.classList.add('@loading');
        }

        _sanitizeDiscountCode(code) {
            return code.replace(/[^a-zA-Z0-9_-]/g, '').substring(0, 50);
        }

        async _applyDiscount(code) {
            this._showCartLoading();
            sessionStorage.setItem('cart_discount_code', code);
            await fetch(`${Routes('cartUpdate')}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: code })
            });
            await this._openDirect();
        }

        async _removeDiscount() {
            this._showCartLoading();
            sessionStorage.removeItem('cart_discount_code');
            await fetch(`${Routes('cartUpdate')}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ discount: '' })
            });
            await this._openDirect();
        }

        _initDiscountControls() {
            document.addEventListener('click', (e) => {
                const $apply = e.target.closest('[data-discount-apply]');
                if ($apply) {
                    const $input = document.querySelector('[data-discount-input]');
                    if (!$input) return;
                    const code = this._sanitizeDiscountCode($input.value.trim());
                    if (code) this._applyDiscount(code);
                    return;
                }

                const $remove = e.target.closest('[data-discount-remove]');
                if ($remove) {
                    this._removeDiscount();
                }
            });

            document.addEventListener('keypress', (e) => {
                if (e.key !== 'Enter') return;
                const $input = e.target.closest('[data-discount-input]');
                if (!$input) return;
                e.preventDefault();
                const code = this._sanitizeDiscountCode($input.value.trim());
                if (code) this._applyDiscount(code);
            });
        }
    });

    // Trigger element - opens fly cart on click (falls back to cart page if disabled)
    customElements.define('cart-notification-trigger', class extends Core {
        render() {
            this.addEventListener('click', this._onClick.bind(this));
        }

        _onClick(e) {
            e.preventDefault();
            // Check if cart-notification element exists (feature enabled)
            if (document.querySelector('cart-notification')) {
                this.publish('cart-notification:open');
            } else {
                // Fallback to cart page
                window.location.href = Routes('cart');
            }
        }
    });

    // Keep custom elements for backwards compatibility but they're not required
    customElements.define('cart-notification-qty-select', class extends Core {
        render() {}
    });

    customElements.define('cart-notification-qty-button', class extends Core {
        render() {}
    });
})();
